<script>
import options from './DitRaaderumCalculatorResultCard.options'

export default options
</script>

<template>
    <NykBasicCard class="nyk-dit-raaderum-calculator__result-card">
        <h2 class="nyk-dit-raaderum-calculator__result-title">
            {{ labels.resultTitle }}
        </h2>
        <div class="nyk-dit-raaderum-calculator__result-content">
            <p class="nyk-dit-raaderum-calculator__result-description">
                {{ labels.resultDescription }}
            </p>
            <div v-if="result" class="nyk-dit-raaderum-calculator__result-amount">
                <p v-if="result.raaderumAvailable" class="nyk-dit-raaderum-calculator__result-value">
                    {{ formatAmount(result.raaderum) }}
                </p>
                <div
                    v-else-if="result.alternativeFinancingAvailable"
                    class="nyk-dit-raaderum-calculator__result-message"
                    v-html="labels.alternativeFinancing">
                </div>
                <p v-else class="nyk-dit-raaderum-calculator__result-message">
                    {{ labels.raaderumUnavailable }}
                </p>
            </div>
        </div>
    </NykBasicCard>
</template>
